const config = require('../config'); const apiConfig = require('../api-config');
const keyBy = require('lodash/keyBy');
const find = require('lodash/find');
const pathResult = require('../resources/path-result');
const apiFactory = require('../resources/portfolios/api-factory');
const serviceFactory = require('../resources/portfolios/service-factory');
const parseRequestMetaData = require('../utils/parse-request-meta-data');


function parseJson(obj) {
  return JSON.stringify(obj);
}

function getTopIndex(obj) {
  if (!obj[0]) return [];
  return obj[0];
}



function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/portfoliooverview/${apiConfig.apiversion}/`,
    baseUrlForTrades: `${config.baseUrl}/trades/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    baseUrlForEntitlement: `${config.baseUrl}/entitlement/${apiConfig.apiversion}/`,
    baseUrlForUserProfile: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`,
    baseUrlForGlobalauth: `${config.baseUrl}/globalauth/${apiConfig.apiversion}/`,
    baseUrlForTrades: `${config.baseUrl}/trades/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api, requestHandler });

  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}portfolios.length`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getPortfolios(req.params.metaData)
          .then(portfolios => res.value(portfolios.length))
          .catch(res.error)
      )))
    .match(`${p}portfolios[{integers:index}][{keys:k}]`, requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getPortfolios(req.params.metaData)
          .then(portfolios => 
            pathResult([req.params.index, req.params.k], res, portfolios))
          .catch(res.error)
      ))
    )
    .match(`${p}portfolios.getData`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getPortfolios(req.params.metaData)
          .then(parseJson)
          .then(response => res.value(response))

          .catch(res.error)
      )))

    .match(`${p}portfolios.top`, requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getPortfolios(req.params.metaData)
          .then(getTopIndex)
          .then(parseJson)
          .then(response => res.value(response))


          .catch(res.error)
      ))
    )

    .match(`${p}portfolios.getInActivePortfolioLength`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getInActivePortfolio(req.params.metaData)
          .then(response => res.value(response.length))
          .catch(res.error)
      )))
    .match(`${p}portfoliosById[{keys:portfolioId}][{keys:key}]`, requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getPortfolios(req.params.metaData)
          .then(portfolios => {
            const parsedMetaData = parseRequestMetaData(req.params.metaData);
            const portfolioById = find(portfolios, { id: req.params.portfolioId, relId: parsedMetaData.portfolio.relId });
            return pathResult([req.params.key], res, portfolioById);
          }))
      ))
    .match(`${p}portfoliosById[{integers:portfolioId}][{keys:key}]`, requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getPortfolios(req.params.metaData)
          .then(portfolios => {
            const parsedMetaData = parseRequestMetaData(req.params.metaData);
            const portfolioById = find(portfolios, { id: req.params.portfolioId.toString(), relId: parsedMetaData.portfolio.relId });
            return pathResult([req.params.key], res, portfolioById);
          }))
      ))
    .match((
      `${p}portfoliosById[{keys:portfolioId}].overallMarketValue.`
      + '["dayChange","netIncome","price","asOfDate"][{keys:key}]'
    ), requests => 
        Promise.all(requests.map(({ req, res }) =>
          service.getOverallMarketValue(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params[3], req.params.key], res))
            .catch(res.error))))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].marketValues.length`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getMarketValues(req.params.portfolioId, req.params.metaData)
            .then(xs => res.value(xs.length))
            .catch(res.error))))
    .match((
      `${p}portfoliosById[{keys:portfolioId}].marketValues[{integers:index}].date`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getMarketValues(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params.index, 'date'], res))
            .catch(res.error))))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].marketValuesData`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getMarketValues(req.params.portfolioId, req.params.metaData)
            .then(parseJson)
            .then(xs => res.value(xs))
            .catch(res.error))))


    .match((
      `${p}portfoliosById[{keys:portfolioId}].marketValues[{integers:index}].price[{keys:k}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getMarketValues(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params.index, 'price', req.params.k], res))
            .catch(res.error))))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].assets.length`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getAssetMarketValue(req.params.portfolioId, req.params.metaData)
            .then(xs => res.value(xs.length))
            .catch(res.error)
        )))
    .match((
      `${p}portfoliosById[{keys:portfolioId}].assets[{integers:index}][{keys:k}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getAssetMarketValue(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params.index, req.params.k], res))
            .catch(res.error))))
    .match((
      `${p}portfoliosById[{keys:portfolioId}].assets[{integers:index}][{keys:k1}][{keys:k2}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getAssetMarketValue(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params.index, req.params.k1, req.params.k2], res))
            .catch(res.error))))
    .match((
      `${p}portfoliosById[{keys:portfolioId}].collateralSurplus`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getCollateralSurplus(req.params.portfolioId, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))
    .match((
      `${p}portfoliosById[{keys:portfolioId}].assetNames`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getAssetNames(req.params.portfolioId, req.params.metaData)
            .then(response => res.value(JSON.stringify(response)))
            .catch(res.error))))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].performanceChart.length`
    ), requests =>
        Promise.all(requests.map(({ req, res }) => {
          //debugger;
          return service.portfoliosChartData(req.params.portfolioId, req.params.metaData)
            .then(xs => {
              //debugger;
              return res.value(xs.length)
            })
            .catch(res.error)
        })))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].performanceChart[{integers:index}][{keys:k}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.portfoliosChartData(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params.index, req.params.k], res))
            .catch(res.error))))


    .match((
      `${p}portfoliosById[{keys:portfolioId}].performanceChart`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.portfoliosChartData(req.params.portfolioId, req.params.metaData)
            .then(parseJson)
            .then(xs => res.value(xs))
            .catch(res.error))))


    .match((
      `${p}portfoliosById[{keys:portfolioId}].performanceLineChart.length`
    ), requests =>
        Promise.all(requests.map(({ req, res }) => {
          //debugger;
          return service.portfoliosLineChartData(req.params.portfolioId, req.params.metaData)
            .then(xs => {
              //debugger;
              return res.value(xs.length)
            })
            .catch(res.error)
        })))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].performanceLineChart[{integers:index}][{keys:k}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.portfoliosLineChartData(req.params.portfolioId, req.params.metaData)
            .then(pathResult([req.params.index, req.params.k], res))
            .catch(res.error))))


    .match((
      `${p}portfoliosById[{keys:portfolioId}].performanceLineChart`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.portfoliosLineChartData(req.params.portfolioId, req.params.metaData)
            .then(parseJson)
            .then(xs => res.value(xs))
            .catch(res.error))))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].portfoliosYTDData[{keys:ran_str}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.portfoliosYTDData(req.params.portfolioId, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))

    .match((
      `${p}portfoliosById[{keys:portfolioId}].currencyExposure[{keys:ran_str}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getCurrencyExposure(req.params.portfolioId, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))
    
        //WMCE- 4443 , BP CONSOLIDATION, TAKING BP VALUE AS INTEGER
        .match((
          `${p}portfoliosById[{integers:portfolioId}].overallMarketValue.`
          + '["dayChange","netIncome","price","asOfDate"][{keys:key}]'
        ), requests => 
            Promise.all(requests.map(({ req, res }) =>
              service.getOverallMarketValue(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params[3], req.params.key], res))
                .catch(res.error))))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].marketValues.length`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getMarketValues(req.params.portfolioId, req.params.metaData)
                .then(xs => res.value(xs.length))
                .catch(res.error))))
        .match((
          `${p}portfoliosById[{integers:portfolioId}].marketValues[{integers:index}].date`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getMarketValues(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params.index, 'date'], res))
                .catch(res.error))))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].marketValuesData`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getMarketValues(req.params.portfolioId, req.params.metaData)
                .then(parseJson)
                .then(xs => res.value(xs))
                .catch(res.error))))
    
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].marketValues[{integers:index}].price[{keys:k}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getMarketValues(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params.index, 'price', req.params.k], res))
                .catch(res.error))))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].assets.length`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getAssetMarketValue(req.params.portfolioId, req.params.metaData)
                .then(xs => res.value(xs.length))
                .catch(res.error)
            )))
        .match((
          `${p}portfoliosById[{integers:portfolioId}].assets[{integers:index}][{keys:k}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getAssetMarketValue(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params.index, req.params.k], res))
                .catch(res.error))))
        .match((
          `${p}portfoliosById[{integers:portfolioId}].assets[{integers:index}][{keys:k1}][{keys:k2}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getAssetMarketValue(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params.index, req.params.k1, req.params.k2], res))
                .catch(res.error))))
        .match((
          `${p}portfoliosById[{integers:portfolioId}].collateralSurplus`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getCollateralSurplus(req.params.portfolioId, req.params.metaData)
                .then(xs => res.value(xs))
                .catch(res.error)
            )))
        .match((
          `${p}portfoliosById[{integers:portfolioId}].assetNames`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getAssetNames(req.params.portfolioId, req.params.metaData)
                .then(response => res.value(JSON.stringify(response)))
                .catch(res.error))))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].performanceChart.length`
        ), requests =>
            Promise.all(requests.map(({ req, res }) => {
              //debugger;
              return service.portfoliosChartData(req.params.portfolioId, req.params.metaData)
                .then(xs => {
                  //debugger;
                  return res.value(xs.length)
                })
                .catch(res.error)
            })))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].performanceChart[{integers:index}][{keys:k}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.portfoliosChartData(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params.index, req.params.k], res))
                .catch(res.error))))
    
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].performanceChart`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.portfoliosChartData(req.params.portfolioId, req.params.metaData)
                .then(parseJson)
                .then(xs => res.value(xs))
                .catch(res.error))))
    
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].performanceLineChart.length`
        ), requests =>
            Promise.all(requests.map(({ req, res }) => {
              //debugger;
              return service.portfoliosLineChartData(req.params.portfolioId, req.params.metaData)
                .then(xs => {
                  //debugger;
                  return res.value(xs.length)
                })
                .catch(res.error)
            })))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].performanceLineChart[{integers:index}][{keys:k}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.portfoliosLineChartData(req.params.portfolioId, req.params.metaData)
                .then(pathResult([req.params.index, req.params.k], res))
                .catch(res.error))))
    
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].performanceLineChart`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.portfoliosLineChartData(req.params.portfolioId, req.params.metaData)
                .then(parseJson)
                .then(xs => res.value(xs))
                .catch(res.error))))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].portfoliosYTDData[{keys:ran_str}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.portfoliosYTDData(req.params.portfolioId, req.params.metaData)
                .then(xs => res.value(xs))
                .catch(res.error)
            )))
    
        .match((
          `${p}portfoliosById[{integers:portfolioId}].currencyExposure[{keys:ran_str}]`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getCurrencyExposure(req.params.portfolioId, req.params.metaData)
                .then(xs => res.value(xs))
                .catch(res.error)
            )))
    
    .match((
      `${p}portfolios.getDashboardData`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getDashboardData(req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))

        
        .match(`${p}portfolio.getOverallMarketValue[{keys:portfolioId}][{keys:guidStr}]`, requests => Promise.all(
          requests.map(({ req, res }) =>
            service.getOverallMarketValueAsOfDate(req.params.portfolioById,req.params.metaData)
              .then(response => res.value(response))
              .catch(res.error)
          )))
          
    .match((
      `${p}portfoliosById[{keys:portfolioId}]getPortfoliosData`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getPortfoliosData(req.params.portfolioId, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))

        .match((
          `${p}portfoliosById[{integers:portfolioId}]getPortfoliosData`
        ), requests =>
            Promise.all(requests.map(({ req, res }) =>
              service.getPortfoliosData(req.params.portfolioId, req.params.metaData)
                .then(xs => res.value(xs))
                .catch(res.error)
            )))
    .match((
      `${p}portfolios.ccyDiscoveryTermsRmia[{keys:language}]`
    ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getCcyDiscoveryTermsRmia(req.params.language, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))

    .match(`${p}portfolios.portfoliosAndStatusData[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.portfoliosAndStatusData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )));

}

module.exports = addRoutes;
